import { stepOrder, stepOrderKorea, stepOrderDefault } from 'constants/stepOrder';

const SELECT_PRODUCT_PATH = '/steps/starter-kit/select-product';

function getActiveRef() {
  if (typeof window === 'undefined') return '';
  const fromUrl = new URLSearchParams(window.location.search).get('ref');
  if (fromUrl) return fromUrl;
  try {
    const stored = localStorage.getItem('NUL_REF');
    return stored ? JSON.parse(stored) : '';
  } catch {
    return '';
  }
}

export const getStepOrderByShippingCountry = (shipCountry, ref = getActiveRef()) => {
  let order;
  switch (shipCountry) {
    case 'Japan':
    case 'Belgium NFR':
    case 'Canada':
    case 'Germany NFR':
    case 'Netherlands NFR':
    case 'Thailand':
    case 'United Kingdom NFR':
    case 'USA':
      order = stepOrder;
      break;
    case 'Korea (the Republic of)':
      order = stepOrderKorea;
      break;
    default:
      order = stepOrderDefault;
  }

  if (ref === 'somastem') {
    return order.filter((step) => step.pathname !== SELECT_PRODUCT_PATH);
  }

  return order;
};
